<template>
  <div>
    <div class="g-desc">
      <img src="../../assets/tongwei/icon1.png" alt="" class="u-icon1">
      <p :class="'m-desc ' + elems.articles[0].summary_font_size">

        {{ elems.articles[0].summary }}
      </p>
      <!-- <div @click.stop="support($event, elems.articles[0].article_id, elems.articles[0])" class="u-supportBox"
        v-if="elems.articles[0].parsing_article_flag">
        <img src="../../assets/tongwei/support.png" alt="" class="u-support">
        <img src="../../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
        {{ elems.articles[0].support_counts }}
      </div> -->
    </div>
    <div class="g-type3">
      <div class="m-box">
        <!-- <a
        :href="
          'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id=' +
          this.elems.elems[0].article_id +
          '&page=' +
          this.index+'&columnId='+this.columnId
        "
        class="g-twTitle"
      >
        {{ elems.elems[0].title }}
      </a> -->
        <router-link :to="'/article/' + this.elems.articles[1].article_id"
          :class="'g-twTitle ' + elems.articles[1].title_font_size" v-if="this.elems.articles[1].article_id != null">{{
              elems.articles[1].title
          }}</router-link>

        <a :href="this.elems.articles[1].article_url" v-else>{{elems.articles[1].title}}</a>
        <p :class="'g-twDesc ' + elems.articles[1].sub_title_font_size">
          {{ elems.articles[1].sub_title }}
        </p>
        <!-- <div @click.stop="support($event, elems.articles[1].article_id, elems.articles[1])" class="u-supportBox"
          v-if="elems.articles[1].parsing_article_flag">
          <img src="../../assets/tongwei/support.png" alt="" class="u-support">
          <img src="../../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
          {{ elems.articles[1].support_counts }}
        </div> -->
      </div>
      <div class="m-box">
        <!-- <a
        :href="
          'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id=' +
          this.elems.elems[1].article_id +
          '&page=' +
          this.index+'&columnId='+this.columnId
        "
        class="g-twTitle"
      >
        {{ elems.elems[1].title }}
      </a> -->
        <router-link :to="'/article/' + this.elems.articles[2].article_id"
          :class="'g-twTitle ' + elems.articles[2].title_font_size" v-if="this.elems.articles[2].article_id != null">{{ elems.articles[2].title }}</router-link>
        
          <a :href="this.elems.articles[2].article_url" v-else>{{elems.articles[2].title}}</a>
          <p :class="'g-twDesc ' + elems.articles[2].sub_title_font_size">
          {{ elems.articles[2].sub_title }}
        </p>
        <!-- <div @click.stop="support($event, elems.articles[2].article_id, elems.articles[2])" class="u-supportBox"
          v-if="elems.articles[2].parsing_article_flag">
          <img src="../../assets/tongwei/support.png" alt="" class="u-support">
          <img src="../../assets/tongwei/supportActive.png" alt="" class="u-supportActive">
          {{ elems.articles[2].support_counts }}
        </div> -->
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    elems: [Array, Object],
    index: [Number, String],
    columnId: [Number, String],
  },
};
</script>

<style lang="scss" scoped>
.g-type3 {
  overflow: hidden;
  border-top: 1px solid #F0F0F0;
  padding-top: .333333rem;
  margin-top: .3rem;

  .g-twTitle {
    margin-bottom: .2rem;
  }
}

.g-desc {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
}

.u-icon1 {
  width: .293333rem;
  height: .333333rem;
  margin-right: .266667rem;
  margin-top: 0;
}

.m-desc {
  font-size: .32rem;
  color: #666;
  text-align: justify;
  line-height: 1.5;
  overflow: hidden;
  position: relative;
}
</style>